import { UnknownAction } from "redux";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../../../store/ApplicationState";
import {
  getCareType,
  getDisciplines,
  getPastMedicalHistory,
  getPsychologicalHistory,
} from "../../../../../actions/Master";
import ServiceRequestUI from "../components/ServiceRequest";
import { resetStates } from "../../../../../actions/Common";
import { DisciplineSearch } from "../../../../../models/Service";
import { getServiceRequest } from "../../../../../actions/Service";
import { withErrorBoundary } from "../../../../../components/custom/structure/components/ErrorBoundary";
import ErrorFallback from "../../../../../components/custom/structure/components/ErrorFallback";
import { getServiceRequestIsRetro } from "actions/AllPatientRecord";

const mapStateToProps = ({
  careTypeState,
  disciplinesState,
  pastMedicalHistoryState,
  psychologicalHistoryState,
  postServiceRequestState,
  patientInformationViewState,
  serviceRequestIsRetroState,
}: ApplicationState) => ({
  careTypeData: careTypeState,
  disciplinesState,
  pastMedicalHistoryData: pastMedicalHistoryState,
  psychologicalHistoryData:
    psychologicalHistoryState,
  serviceRequestUpdateData: postServiceRequestState,
  patientHeaderData: patientInformationViewState,
  serviceRequestIsRetroData: serviceRequestIsRetroState,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, UnknownAction >) => {
  return {
    getDisciplines: (payload: DisciplineSearch) => {
      dispatch(getDisciplines(payload));
    },

    getCareType: () => {
      dispatch(getCareType());
    },

    getPastMedicalHistory: () => {
      dispatch(getPastMedicalHistory());
    },

    getPsychologicalHistory: () => {
      dispatch(getPsychologicalHistory());
    },
    resetStates: (actionType: string[]) => {
      dispatch(resetStates(actionType));
    },
    getServiceRequest: (referralId: number, startOfCareDate?: string) => {
      dispatch(getServiceRequest(referralId, startOfCareDate));
    },
    getServiceRequestIsRetro: (socDate: string, payload: any) => {
      dispatch(getServiceRequestIsRetro(socDate, payload));
    },
  };
};

const ConnectedServiceRequestUI = connect(mapStateToProps, mapDispatchToProps)(ServiceRequestUI);

ConnectedServiceRequestUI.displayName = "Service Request UI";

export default withErrorBoundary(ConnectedServiceRequestUI, {
  fallback: ErrorFallback,
});
